<template>
  <button
    :class="[{ fluid }, type, 'button']"
    :disabled="disabled || loading"
    class="base-button"
  >
    <div v-if="loading" class="base-button__loader">
      <loading-spinner />
    </div>
    <slot v-else>button text</slot>
  </button>
</template>

<script>
import LoadingSpinner from "@/components/LoadingSpinner"
export default {
  components: {
    LoadingSpinner
  },
  props: {
    type: {
      type: String,
      default: "filled",
      validator(value) {
        // The value must match one of these strings
        return ["filled", "hollowed", "basic"].indexOf(value) !== -1
      }
    },
    fluid: {
      type: Boolean,
      default: true
    },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  }
}
</script>

<style scoped rel="stylesheet/scss" lang="scss">
@import "@/styles/variables.scss";
.base-button {
  min-height: 49px;
  position: relative;
  &__loader {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.button {
  border: 2px solid $color-secondary;
  border: 2px solid var(--color-secondary, $color-secondary);
  outline: none;
  border-radius: 40px;
  padding: 16px 24px;
  color: white;
  transition: all 0.2s ease;
  font-weight: 800;
  font-size: 12px;
  text-transform: uppercase;

  &:not(:disabled) {
    cursor: pointer;
  }

  &:disabled {
    border-color: $color-secondary--light;
    border-color: var(--color-secondary--light, $color-secondary--light);
  }

  &.fluid {
    width: 100%;
  }

  &.filled {
    background: $color-secondary;
    background: var(--color-secondary, $color-secondary);

    &:focus,
    &:hover {
      background: $color-secondary--dark;
      background: var(--color-secondary--dark, $color-secondary--dark);
      border-color: $color-secondary--dark;
      border-color: var(--color-secondary--dark, $color-secondary--dark);
      &:not(:disabled) {
        box-shadow: 0 20px 40px 0 rgba(0, 0, 0, 0.16);
      }
    }

    &:disabled,
    &:disabled:focus,
    &:disabled:hover {
      background: $color-secondary--light;
      background: var(--color-secondary--light, $color-secondary--light);
      border-color: $color-secondary--light;
      border-color: var(--color-secondary--light, $color-secondary--light);
    }
  }

  &.hollowed {
    background: transparent;
    color: $color-secondary;
    color: var(--color-secondary, $color-secondary);

    &:not(:disabled):hover {
      color: white;
      background: $color-secondary;
      background: var(--color-secondary, $color-secondary);
    }
    &:disabled {
      color: $color-secondary--light;
      color: var(--color-secondary--light, $color-secondary--light);
      border-color: $color-secondary--light;
      border-color: var(--color-secondary--light, $color-secondary--light);
    }
  }

  $color-basic--disabled: lighten($color-secondary--light, 8%);
  &.basic {
    border: none;
    background: transparent;
    color: $color-secondary;
    color: var(--color-secondary, $color-secondary);
    &:not(:disabled) {
      &:hover,
      &:focus {
        background: $color-basic--disabled;
        border-color: $color-basic--disabled;
      }
    }

    &:disabled {
      color: $color-secondary--light;
      color: var(--color-secondary--light, $color-secondary--light);
    }
  }
}
</style>
